import React from "react"
import { Box, Switch, Typography } from "@mui/material"
import { dsColorNew } from "@palette"
import OfficeScopePicker from "Pages/DsRepricing/@components/OfficeScopePicker"
import useDsRepricingDataInfo from "Pages/DsRepricing/Page/@hooks/useDataInfo"
import { dsRepricingDrawerData } from "Pages/DsRepricing/Page/@signals"

export default function DsRepricingExcludeOffices() {
	const d = dsRepricingDrawerData.peek()
	const { dataInfo: idsInfo, setDataInfo: setIds } = useDsRepricingDataInfo(d.filterGroupOffices ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useDsRepricingDataInfo(d.filterGroupOfficesExclusion ?? false)

	const isExclusion = exclInfo.value
	const ids = idsInfo.value ?? []

	const updateMode = (checked) => setExcl(checked, 'filterGroupOfficesExclusion')
	const updateIds = (_, opts) => setIds(opts ?? [], 'filterGroupOffices')

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
				<Switch checked={isExclusion} onChange={e => updateMode(e.target.checked)} size="small"/>
				<Typography sx={{ fontSize: 14, color: dsColorNew.textDark, fontWeight: 500 }}>
					{isExclusion ? 'Exclude offices' : 'Include offices'}
				</Typography>
			</Box>
			{/* Office GROUPS and offices in one list, from the catalogue the
			    engine matches against. This used to be Price Seeker's own
			    `OFFICES_GROUP`, which the engine has never heard of: the
			    scope it produced could not match an office, and said
			    nothing about it. No `requireMapped` here — a strategy is
			    matched on `dim_location.code` and never needs the Price
			    Seeker id; only the sweep does. */}
			<OfficeScopePicker
				label="Offices and office groups"
				placeholder={isExclusion ? 'All offices except…' : 'All offices'}
				value={ids.map(o => (typeof o === 'string' ? o : o?.value ?? o))}
				onChange={(codes) => updateIds(null, codes)}
				helperText="A group covers every office inside it. Leave empty for all offices."
			/>
		</Box>
	)
}